import {Component, NgModule, ViewEncapsulation, Output, Input} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import "reflect-metadata";

let autoincrement = 0;

// ref: http://stackoverflow.com/questions/41296327/angular2-bootstrap-component-with-input-values
// ref: https://github.com/angular/angular/issues/1858
// ref: http://stackoverflow.com/questions/33326376/angular-2-component-input-not-working/33329647#33329647
export function init(domEl, McfComponentModule, McfComponent, props = {}) {
    let innerHTML = domEl.innerHTML;
    let attrs = domEl.attributes;
    domEl.outerHTML = '<mcf-wrapper' + autoincrement + '></mcf-wrapper' + autoincrement + '>';
    for (let i=0; i < attrs.length; i++) {
      let {name, value} = attrs[i];
      if (!props.hasOwnProperty(name)) props[name] = value;
    }
    let McfWrapperComponent = wrapComponent(McfComponent, props, innerHTML)
    @NgModule({
        imports: [McfComponentModule],
        declarations: [McfWrapperComponent],
        bootstrap: [McfWrapperComponent]
    })
    class McfModule {}
    platformBrowserDynamic().bootstrapModule(McfModule);
}


export function wrapComponent(McfComponent, props, innerHTML) {
    let componentMeta = Reflect.getMetadata('annotations', McfComponent);
    let propsMeta = Reflect.getMetadata('propMetadata', McfComponent)
    const outputsRegistry = Object.create(null);
    const inputsRegistry = Object.create(null);
    Object.keys(propsMeta).forEach(function(propName) {
        const propMeta = propsMeta[propName];
        const propType = Reflect.getMetadata("design:type", McfComponent.prototype, propName);
        if (
          propType === Array
          && props.hasOwnProperty(propName)
          && typeof props[propName] == 'string'
        ) {
          props[propName] = props[propName].split(',');
        }
        propMeta.forEach(dec => {
            if (dec instanceof Output) outputsRegistry[propName] = true;
            if (dec instanceof Input) inputsRegistry[propName] = true;
        });
    });
    let componentName;
    for (let mi = 0; mi < componentMeta.length; mi++) {
        if (componentMeta[mi] instanceof Component) {
            componentName = componentMeta[mi].selector;
            break;
        }
    }
    let propsTemplate = Object.keys(props).map(propName => {
        let formatting = {left: '', right: '', suffix: ''};
        if (outputsRegistry[propName]) formatting = {left: '(', right: ')', suffix: '($event)'}
        if (inputsRegistry[propName]) formatting = {left: '[', right: ']', suffix: ''}
        return formatting.left + propName + formatting.right + '="props.' + propName + formatting.suffix + '"';
    }).join(' ')
    const template = '<' + componentName + ' ' + propsTemplate + ' >' + innerHTML + '</' + componentName + '>';
    @Component({
        selector: 'mcf-wrapper' + autoincrement,
        template,
        encapsulation: ViewEncapsulation.None
    })
    class McfWrapper {
        props: any;

        constructor() {
            this.props = props;
        }
    }
    autoincrement++;
    return McfWrapper
}



// WEBPACK FOOTER //
// node_modules/tslint-loader?/~/mcf-webpack-config/tslint.json!./src/index.ts